// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2pZOI","buttons":"SendReceipts_buttons__xMNzo","email":"SendReceipts_email__2PtLk","bookApptTitle":"SendReceipts_bookApptTitle__1EfYx"};